import React from 'react';
import PropTypes from 'prop-types';
import { RatingsList } from '@src/components/RatingsList';
import './styles.scss';

export const CompanyRatingsCard = ({ ratings }) => {
  return (
    <div className="company-ratings">
      <h3 className="company-ratings__card-title">Overall Score</h3>
      <div className="company-ratings__total-rating">{ratings.total ? ratings.total.toFixed(1) : '-'}</div>
      <RatingsList ratings={ratings} />
    </div>
  );
};

CompanyRatingsCard.propTypes = {
  ratings: PropTypes.shape({
    total: PropTypes.number.isRequired,
  }).isRequired,
};
